import { useMemo } from 'react';

// material-ui
import { Theme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';

// project-imports
import FullScreen from './FullScreen';
import Localization from './Localization';
import MegaMenuSection from './MegaMenuSection';
import Message from './Message';
import Profile2 from './Profile2';
import MobileSection from './MobileSection';
import Notification from './Notification';
import Profile from './Profile';
import Search from './Search';
import { RouteSquare } from 'iconsax-reactjs';


import { MenuOrientation } from 'config';
import useConfig from 'hooks/useConfig';
import DrawerHeader from 'layout/Dashboard/Drawer/DrawerHeader';
import IconButton from 'components/@extended/IconButton';
import { Link } from 'react-router-dom';
import { URLS } from 'common/constants';

// ==============================|| HEADER - CONTENT ||============================== //

export default function HeaderContent() {
  const {
    state: { menuOrientation }
  } = useConfig();

  const downLG = useMediaQuery((theme: Theme) => theme.breakpoints.down('lg'));

  const localization = useMemo(() => <Localization />, []);

  const megaMenu = useMemo(() => <MegaMenuSection />, []);

  return (
    <>
      {menuOrientation === MenuOrientation.HORIZONTAL && !downLG && <DrawerHeader open={true} />}
      {/* <Search /> */}
      {/*
      {!downLG && megaMenu}
      */}
      <Box sx={{ width: 1, ml: 1 }} />
      {/*
      <Notification />
      {!downLG && <FullScreen />}
      */}
      {localization}

      <a href={URLS.projects} aria-label="Go to dashboard">
        <IconButton 
          color='default' 
          sx={{ml: -1, mr: 0.5}}
        >
          <RouteSquare />
        </IconButton>
      </a>      

      <Profile2 />
      {/* <Profile /> */}
      {/*
      {downLG && <MobileSection />}
      */}
      
    </>
  );
}
